<template>
  <div>
    <via-nav-bar
      title="修改插件"
      @click-left="$router.$back()"
    >
      <div
        slot="right"
        class="nav-right"
        @click="confirm"
      >确定</div>
    </via-nav-bar>

    <!-- 表单 -->
    <van-cell-group>
      <van-field
        v-model="form.name"
        required
        clearable
        :maxlength="15"
        label="插件名字"
        placeholder="给插件起一个名字吧"
      />
      <van-field
        v-model="form.introduction"
        required
        clearable
        :maxlength="30"
        label="插件简介"
        placeholder="30个字以内"
      />
      <van-cell
        required
        is-link
        title="插件图标"
        :value="iconValue"
        @click="selectIcon"
      />
      <van-cell
        required
        is-link
        title="插件说明书"
        :value="docValue"
        @click="docInput"
      />

      <!-- 插件tag选择 -->
      <van-collapse
        v-model="collapseActive"
        :border="false"
      >
        <van-collapse-item
          :border="false"
          title="插件归类"
          name="tag"
          :value="tagValue"
        >
          <van-checkbox-group
            v-model="form.tagIds"
            class="checkbox-group"
          >
            <van-checkbox
              v-for="tag in tags"
              :key="tag.id"
              class="checkbox-item"
              :name="tag.id"
            >
              {{ tag.name }}
            </van-checkbox>
          </van-checkbox-group>
        </van-collapse-item>

        <!-- 插件supportBrowser选择 -->
        <van-collapse-item
          :border="false"
          title="支持的浏览器"
          name="supportBrowser"
          :value="supportBrowserValue"
        >
          <van-checkbox-group
            v-model="form.supportBrowser"
            class="checkbox-group"
          >
            <van-checkbox
              v-for="browser in browsers"
              :key="browser"
              class="checkbox-item"
              :name="browser"
            >
              {{ browser }}
            </van-checkbox>
          </van-checkbox-group>
        </van-collapse-item>
      </van-collapse>

    </van-cell-group>
  </div>
</template>

<script>
import { Field, Cell, CellGroup, Collapse, CollapseItem, Checkbox, CheckboxGroup } from 'vant'

export default {
  name: 'UpdatePlugin',
  components: {
    [Field.name]: Field,
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup,
    [Collapse.name]: Collapse,
    [CollapseItem.name]: CollapseItem,
    [Checkbox.name]: Checkbox,
    [CheckboxGroup.name]: CheckboxGroup
  },
  data() {
    return {
      form: {
        name: '',
        introduction: '',
        doc: '',
        icon: '',
        iconColor: '',
        iconBgColor: '',
        supportBrowser: [],
        tagIds: []
      },
      tags: [],
      browsers: ['via浏览器', 'alook浏览器', '其他浏览器'],
      collapseActive: [],
      originId: null
    }
  },
  computed: {
    iconValue() {
      if (!this.form.icon || !this.form.iconBgColor || !this.form.icon) {
        return '未选择'
      }
      return '已选择'
    },
    docValue() {
      if (!this.form.doc) {
        return '未填写'
      }
      return '已填写'
    },
    supportBrowserValue() {
      if (!this.form.supportBrowser || this.form.supportBrowser.length === 0) {
        return '未选择'
      }
      return '已选择'
    },
    tagValue() {
      if (!this.form.tagIds || this.form.tagIds.length === 0) {
        return '未选择'
      }
      return '已选择'
    }
  },
  mounted() {
    this.$api.pluginTag.findAll().then(res => {
      this.tags = res.data
    })
  },
  activated() {
    if (!this.originId || String(this.$route.params.id) !== String(this.originId)) {
      this.getPluginInfo(this.$route.params.id)
    }
    this.initData()
  },
  methods: {
    initData() {
      // 从vuex获取图标信息
      const iconData = this.$store.getters['makeIcon/data']
      const iconkey = 'updatePlugin'
      if (iconData[iconkey]) {
        const { icon, iconBgColor, iconColor } = iconData[iconkey]
        this.form.icon = icon
        this.form.iconColor = iconColor
        this.form.iconBgColor = iconBgColor
      }

      // 从vuex获取说明文档
      const docData = this.$store.getters['docEdit/data']
      const dockey = 'updatePlugin'
      if (docData[dockey]) {
        const doc = docData[dockey]
        this.form.doc = doc
      }
    },
    // 获取这个插件的信息
    getPluginInfo(id) {
      this.$store.commit('globalData/updateLoading', true)
      this.$api.plugin.findById(id).then(res => {
        const {
          id,
          name,
          introduction,
          doc,
          icon,
          iconColor,
          iconBgColor,
          supportBrowser,
          tags
        } = res.data
        const tagIds = tags.map(tag => tag.id)
        this.form = {
          name,
          introduction,
          doc,
          icon,
          iconColor,
          iconBgColor,
          supportBrowser,
          tagIds
        }
        this.originId = id
        this.$store.commit('makeIcon/updateData', { ...this.$store.getters['makeIcon/data'], updatePlugin: { icon, iconColor, iconBgColor }})
        this.$store.commit('docEdit/updateData', { ...this.$store.getters['docEdit/data'], updatePlugin: doc })
        this.$store.commit('globalData/updateLoading', false)
      }).catch(() => this.$store.commit('globalData/updateLoading', false))
    },
    selectIcon() {
      this.$router.$push({
        name: 'MakeIcon',
        params: {
          storeKey: 'updatePlugin'
        }
      })
    },
    docInput() {
      this.$router.$push({
        name: 'DocEdit',
        params: {
          storeKey: 'updatePlugin'
        }
      })
    },
    confirm() {
      if (!this.validatedForm()) {
        return
      }
      const {
        name,
        introduction,
        doc,
        icon,
        iconColor,
        iconBgColor,
        supportBrowser,
        tagIds
      } = this.form
      this.$store.commit('globalData/updateLoading', true)
      this.$api.plugin.update(this.$route.params.id, {
        name,
        introduction,
        doc,
        icon,
        iconColor,
        iconBgColor,
        supportBrowser,
        tagIds
      }).then(res => {
        this.$store.commit('globalData/updateLoading', false)
        this.$toast.success('插件修改成功')
        this.$store.dispatch('globalData/getMeInfo')
      }).catch(() => this.$store.commit('globalData/updateLoading', false))
    },
    // 校验表单
    validatedForm() {
      const {
        name,
        introduction,
        doc,
        icon,
        iconColor,
        iconBgColor,
        tagIds,
        supportBrowser
      } = this.form
      if (!name) {
        this.$toast.fail('插件名字不能为空')
        return false
      }
      if (!introduction) {
        this.$toast.fail('插件简介不能为空')
        return false
      }
      if (!icon || !iconColor || !iconBgColor) {
        this.$toast.fail('请先选择插件图标')
        return false
      }
      if (!doc) {
        this.$toast.fail('请先填写插件说明书')
        return false
      }
      if (!tagIds || tagIds.length === 0) {
        this.$toast.fail('请选择插件归类')
        return false
      }
      if (tagIds.length > 4) {
        this.$toast.fail('插件归类只能选4个以内')
        return false
      }
      if (!supportBrowser || supportBrowser.length === 0) {
        this.$toast.fail('请选择支持的浏览器')
        return false
      }
      return true
    }
  }
}
</script>

<style scoped>
.nav-right {
  color: var(--themeColor)
}
.checkbox-group {
  display: flex;
  flex-wrap: wrap;
  width: 100%;
}
.checkbox-item {
  margin-right: 30px;
  margin-bottom: 15px;
}
</style>
